import React, {Component} from 'react'
import {observer} from 'mobx-react'

import SpanLink from 'lib/control/SpanLink'

import Select from './../../../control/DependentSelect'

import EntitySelect from './EntitySelect'

import styles from './ProfileCatalogEntitiesSelect.less'
import Iconui from "lib/struct/iconui/Iconui";

const {
    'selection-block': selection_block_class,
    'entity-block': entity_block_class,
    'type-wrapper': type_wrapper_class,
    'entity-wrapper': entity_wrapper_class,
    'delete-link': delete_link_class,
    'add-link-wrapper': add_link_wrapper_class,
} = styles

@observer export default class ProfileCatalogEntitiesSelect extends Component {
    render() {

        const {context, campaign} = this.props
        const catalog_selection = campaign.catalog_selection

        const with_categories = context.categories.length
        const with_sets = context.sets.length
        const with_types = context.product_types.length

        return (
            <div className={selection_block_class}>
                <div>
                    {
                        catalog_selection.catalog_selection_entities_union.map(entity => (
                            <div
                                key={entity.type}
                                className={entity_block_class}
                            >
                                <div className={type_wrapper_class}>
                                    <Select
                                        options={catalog_selection.getAvailableEntityTypeOptions(entity.type, with_categories, with_sets, with_types)}
                                        value={entity.type}
                                        onChange={e => entity.setType(e.target.value)}
                                        state={context.form_state}
                                    />

                                    {
                                        catalog_selection.catalog_selection_entities_union.length > 1 ? (
                                            <SpanLink
                                                onClick={() => catalog_selection.removeEntityByType(entity.type)}
                                                className={delete_link_class}
                                            >
                                                <Iconui name="delete" />
                                            </SpanLink>
                                        ) : (null)
                                    }
                                </div>
                                <div className={entity_wrapper_class}>
                                    <EntitySelect
                                        context={context}
                                        entity={entity}
                                    />
                                </div>
                            </div>
                        ))
                    }
                </div>

                <div className={add_link_wrapper_class}>
                    {
                        catalog_selection.getAvailableEntityTypes(null, with_categories, with_sets, with_types).length > 0 ? (
                            <SpanLink
                                onClick={() => catalog_selection.addNewEntity(with_categories, with_sets, with_types)}>
                                <Iconui name="add" /> Добавить
                            </SpanLink>
                        ) : (null)
                    }
                </div>
            </div>
        )
    }
}